export default "__VITE_ASSET__DqKeCPkj__"